import axios from 'axios'
import { config } from '../assets/config/config'

const apiUrl = config.api.url

const getUsers = ({ page, limit = config.users.resultsPerPage, name, email, lastNDays, minTasks, maxTasks, sortBy }) => {
  // Construct query string
  let queryParams = `?limit=${limit}&page=${page}`;

  if (name) {
    queryParams += `&name=${name}`;
  }
  if (email) {
    queryParams += `&email=${email}`;
  }
  if (sortBy) {
    queryParams += `&sortBy=${sortBy}`;
  }
  if (lastNDays) {
    queryParams += `&lastNDays=${lastNDays}`;
  } else if (lastNDays === 0) {
    queryParams += `&lastNDays=0`;
  }
  if (minTasks) {
    queryParams += `&minTasks=${minTasks}`;
  } else {
    queryParams += `&minTasks=0`;
  }
  if (maxTasks) {
    queryParams += `&maxTasks=${maxTasks}`;
  } else if (maxTasks === 0) {
    queryParams += `&maxTasks=0`;
  }

  return axios.get(`${apiUrl}/v1/users${queryParams}`, {})
    .then(response => {
      return response.data;
    });
}

const createUser = (username, businessname, email, password, role) => {
	return axios.post(`${apiUrl}/v1/users`, {
    name: username,
    businessname: businessname,
    email: email,
    password: password,
    role: role,
  })
}

const updateUserPassword = (userId, password) => {
	return axios.patch(`${apiUrl}/v1/users/${userId}`, {
    password: password
  })
}

const updateUserNewsletterPreferences = (userId, isNewsletterSubscribed) => {
  return axios.patch(`${apiUrl}/v1/users/${userId}/newsletter-preferences`, {
    isNewsletterSubscribed: isNewsletterSubscribed,
  })
}

const updateUserDetails = (userId, username, email) => {
	return axios.patch(`${apiUrl}/v1/users/${userId}`, {
    name: username,
    email: email,
  })
}

const processUserSource = (userId, source, bonusCredits) => {
  return axios.patch(`${apiUrl}/v1/users/${userId}/process-source`, {
    source: source,
    bonusCredits: bonusCredits,
  });
};

const deleteUser = (userId) => {
	return axios.delete(`${apiUrl}/v1/users/${userId}`, {})
}

const getUser = (userId) => {
  return axios.get(`${apiUrl}/v1/users/${userId}`, {})
}

const getAllUsersBasicInfo = () => {
  return axios.get(`${apiUrl}/v1/users/basic`, {})
    .then(response => {
      return response.data;
    });
}

const addFeatureRequest = (userId, feature) => {
  return axios.post(`${apiUrl}/v1/users/${userId}/feature-requests`, {
    feature: feature,
  });
}

const removeFeatureRequest = (userId, feature) => {
  return axios.delete(`${apiUrl}/v1/users/${userId}/feature-requests/${feature}`);
}

const getAuthKey = (userId) => {
  return axios.get(`${apiUrl}/v1/users/${userId}/get-auth-key`);
}

const refreshAuthKey = (userId) => {
  return axios.post(`${apiUrl}/v1/users/${userId}/refresh-auth-key`);
}

const recordCoffeePurchase = (coffeeCount, amount, orderId) => {
  return axios.post(`${apiUrl}/v1/users/bought-coffee`, {
    coffeeCount,
    amount,
    orderId
  });
}

export const userService = {
  getUsers,
  getAllUsersBasicInfo,
  getUser,
  createUser,
  updateUserPassword,
  updateUserDetails,
  deleteUser,
  processUserSource,
  addFeatureRequest,
  removeFeatureRequest,
  getAuthKey,
  refreshAuthKey,
  updateUserNewsletterPreferences,
  recordCoffeePurchase,
}